app.controller('patientPersonalDataController', ['$rootScope', '$scope', '$state', '$stateParams', '$mdDialog', '$translate', 'objectHelper', 'baseModel', 'applicationModel', 'userModel', 'patientModel', 'dictionaryModel', 'nfzOfficeModel', 'visitModel', 'fileUploadModel', 'attachmentModel', 'attachmentFileModel', 'statementModel', 'config',
    function ($rootScope, $scope, $state, $stateParams, $mdDialog, $translate, objectHelper, baseModel, applicationModel, userModel, patientModel, dictionaryModel, nfzOfficeModel, visitModel, fileUploadModel, attachmentModel, attachmentFileModel, statementModel, config) {

        var listeners = {};

        function checkAllFilesLoaded() {
            function check(element) {
                return (element.loaded == true);
            }

            return $scope.fileList.every(check);
        }

        function loadPatientAttachments() {
            $scope.fileList = [];
            if($scope.patient.attachments.length) {
                $scope.patient.attachments.forEach(function(element) {
                    $scope.fileList.push({ loaded: true, data: element})
                });
            }
        }

        function aggregateAuthorizedPersons() {
            var args = Array.prototype.slice.call(arguments);
            var tmpArray = [];
            args.forEach(function(array) {
                tmpArray = tmpArray.concat(array);
            });
            return tmpArray;
        }

        function setData() {
            $scope.patient = new PatientVO();
            $scope.patient.authorizedPersons = [];
            $scope.guardians = []; //todo fix when backend will be ready
            $scope.patient.attachments = [];
            $scope.citizenshipList = null;
            $scope.stateList = null;

            $scope.forms = {
                personalData: null
            };

            $scope.visitId = $stateParams.visitId;
            $scope.genderTypes = Object.keys(Enum.GENDER);
            $scope.identityDocumentTypes = Object.keys(Enum.IDENTITY_DOCUMENT_TYPE);

            $scope.presentDate = new Date();
            $scope.phoneRegExp = '^\\d+$';
            $scope.numbersOnlyRegExp = '^\\d+$';
            $scope.fileList = [];

            $scope.publishPatientData = false;
            $scope.weightScale = [1,2,3,4,5,6,7,8,9,10];
            $scope.attachmentsLoaded = false;

            $scope.statementCriteria = new StatementCriteria();
            $scope.statementCriteria.patientId = $stateParams.patientId;

            $scope.stateOfHealthAuthorizedPersons = [];
            $scope.medicalDocumentationAuthorizedPersons = [];



        }

        function setPermissions() {
        }

        function setListeners() {

            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });

            $scope.$on(Event.DICTIONARY.GET_DICTIONARY_ELEMENT_DATA_PAGE.SUCCESS, function (event, dataPage, code) {
                if(code === Constant.DICTIONARY_CODE.CITIZENSHIP) {
                    $scope.citizenshipList = dataPage.data;
                    $scope.citizenshipList.unshift(_.remove($scope.citizenshipList, function(citizenship) {
                        return citizenship.id == 167; //hax!! żeby Polska była Polską
                    })[0]);
                }
                if(code === Constant.DICTIONARY_CODE.STATE) {
                    $scope.stateList = dataPage.data;
                }
            });

            $scope.$on(Event.NFZ_OFFICE.GET_DATA_PAGE.SUCCESS, function(event, dataPage) {
                $scope.nfzOfficeList = dataPage.data;
            });

            $scope.$on(Event.PATIENT.DELETE_AUTHORIZED_PERSON.SUCCESS, function(event, dataPage) {
                patientModel.getById($stateParams.patientId);
                statementModel.getDataPage($scope.statementCriteria);
            });

            $scope.$on(Event.ATTACHMENT.DELETE.SUCCESS, function() {
                patientModel.getById($stateParams.patientId);
            });

            $scope.$on(Event.STATEMENT.DELETE.SUCCESS, function() {
                statementModel.getDataPage($scope.statementCriteria);
            });

            $scope.$on(Event.PATIENT.GET_BY_ID.SUCCESS, function(evt, data) {
                $scope.patient = data;

                if (config.DEMO) {
                    $scope.firstVisitDataFill = false;
                } else {
                    $scope.firstVisitDataFill = $scope.patient.toBeVerified;
                }

                if(!$scope.patient.registeredAddress) {
                    $scope.patient.registeredAddress = new AddressVO();
                }

                if($scope.patient.correspondenceAddress && $scope.patient.registeredAddress.id === $scope.patient.correspondenceAddress.id) {
                    $scope.patient.correspondenceAddress = $scope.patient.registeredAddress;
                    $scope.patient.correspondenceAddressSameAsRegisteredAddress = true;
                } else if(!$scope.patient.correspondenceAddress) {
                    $scope.patient.correspondenceAddress = $scope.patient.registeredAddress;
                    $scope.patient.correspondenceAddressSameAsRegisteredAddress = true;
                }
            });

            $scope.$on(Event.STATEMENT.GET_DATA_PAGE.SUCCESS, function(event, dataPage) {
                $scope.statements = dataPage.data;
                dataPage.data.forEach(function(element) {
                    if(element.stateOfHealthDataAccess) {
                        $scope.stateOfHealthAuthorizedPersons.push(element.authorizedPerson);
                    }
                    if(element.medicalDataAccess) {
                        $scope.medicalDocumentationAuthorizedPersons.push(element.authorizedPerson);
                    }
                });

                loadPatientAttachments();
            });

            $scope.$on(Event.FILE_UPLOAD.UPLOAD_FILE.SUCCESS, function(event, attachmentFile, file) {
                var attachment = new AttachmentVO();
                attachment.name = attachmentFile.fileName;
                attachment.attachmentFiles = [attachmentFile];
                patientModel.saveAttachment($scope.patient, attachment).then(function (savedAttachment) {
                    $scope.patient.attachments.push(savedAttachment);
                });
            });

            listeners.onPatientUpdate = function (patient) {
                if($state.current.name.indexOf(Constant.STATE.APP.PATIENT.VIEW.STATE_OF_HEALTH.STATE_OF_HEALTH) == -1 && $scope.firstVisitDataFill && $scope.visitId.length > 0 && $scope.hasRightToVisitCardModule()) {
                    $scope.beginFirstVisit();
                }
                patientModel.getById($stateParams.patientId);
                statementModel.getDataPage($scope.statementCriteria);
                $scope.savingInProgress = false;
            }
        }

        function setActions() {

            $scope.grantPermissionToUsePatientDataInKnowledgeDatabase = function() {
                $scope.patient.knowledgeDatabaseWeight = 1;
            };

            $scope.addAuthorizedPerson = function() {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/popup-authorized-person.html',
                    controller: 'popupAuthorizedPersonController',
                    resolve: {
                        authorizedPersonData: function() {
                            return null;
                        }
                    }
                }).then(function(data) {
                    patientModel.saveAuthorizedPerson($scope.patient, data).then(function (savedAuthorizedPerson) {
                        $scope.patient.authorizedPersons.push(savedAuthorizedPerson);
                    });
                }, function(error){

                });
            };

            $scope.editAuthorizedPerson = function(authorizedPerson) {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/popup-authorized-person.html',
                    controller: 'popupAuthorizedPersonController',
                    resolve: {
                        authorizedPersonData: function() {
                            return authorizedPerson;
                        }
                    }
                }).then(function(data) {
                    var index = $scope.patient.authorizedPersons.indexOf(authorizedPerson);
                    $scope.patient.authorizedPersons[index] = data;
                    patientModel.updateAuthorizedPerson($scope.patient, data);
                }, function(error){

                });
            };

            $scope.deleteAuthorizedPerson = function(authorizedPerson) {
                var confirm = $mdDialog.confirm({
                    title: $translate.instant('T.MODULE.VISIT.AUTHORIZED_PERSON_DELETE_CONFIRMATION'),
                    ok: $translate.instant('T.UI.APPLICATION.YES'),
                    cancel: $translate.instant('T.UI.APPLICATION.NO')
                });
                $mdDialog.show(confirm).then(function() {
                    _.remove($scope.patient.authorizedPersons, function (person) {
                        return person === authorizedPerson
                    });

                    patientModel.deleteAuthorizedPerson($scope.patient, authorizedPerson);
                }, function() {
                    return false;
                });
            };

            $scope.addGuardian = function() {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/popup-guardian.html',
                    controller: 'popupGuardianController',
                    resolve: {
                        guardianData: function() {
                            return null;
                        }
                    }
                }).then(function(data) {
                    $scope.patient.guardians.push(data);
                    patientModel.update($scope.patient);
                }, function(error){

                });
            };

            $scope.editGuardian = function(guardian) {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/popup-guardian.html',
                    controller: 'popupGuardianController',
                    resolve: {
                        guardianData: function() {
                            return guardian;
                        }
                    }
                }).then(function(data) {
                    var mapped = $scope.patient.guardians.map(function(element) { return element.id });
                    var index = mapped.indexOf(data.id);

                    if(index != -1) {
                        $scope.patient.guardians[index] = data;
                    } else {
                        $scope.patient.guardians.push(data);
                    }

                    patientModel.update($scope.patient);
                }, function(error){

                });
            };

            $scope.deleteGuardian = function(guardian) {
                var confirm = $mdDialog.confirm({
                    title: $translate.instant('T.MODULE.VISIT.GUARDIAN_DELETE_CONFIRMATION'),
                    ok: $translate.instant('T.UI.APPLICATION.YES'),
                    cancel: $translate.instant('T.UI.APPLICATION.NO')
                });
                $mdDialog.show(confirm).then(function() {
                    _.remove($scope.patient.guardians, function (person) {
                        return person === guardian
                    });

                    patientModel.update($scope.patient);
                }, function() {
                    return false;
                });
            };

            $scope.changeSameAsRegistered = function() {
                if($scope.patient.correspondenceAddressSameAsRegisteredAddress) {
                   $scope.patient.correspondenceAddress = $scope.patient.registeredAddress;
                } else {
                    if($scope.patient.correspondenceAddress === $scope.patient.registeredAddress)  {
                        $scope.patient.correspondenceAddress = angular.copy($scope.patient.correspondenceAddress);
                        delete $scope.patient.correspondenceAddress.id;
                    }
                }
            };


            $scope.savePatientData = function () {
                $scope.forms.personalData.$setSubmitted();
                if($scope.forms.personalData.$valid) {
                    $scope.savingInProgress = true;
                    patientModel.update($scope.patient).then(listeners.onPatientUpdate, function () {
                        $scope.savingInProgress = false;
                    });

                }
            };

            $scope.beginFirstVisit = function() {
                $state.go(Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD, { patientId: $scope.patientId, visitId: $scope.visitId, visitType: $stateParams.visitType });
            };

            $scope.enclose = function (fileInput) {
                if(fileInput.length > 0) {
                    fileInput.forEach(function (file) {
                        fileUploadModel.uploadFile({data:file});
                    });
                }
            };

            $scope.deleteAttachment = function(fileToDelete) {
                if(fileToDelete.id) {
                    attachmentModel.delete(fileToDelete.id);
                }

                _.remove($scope.fileList, function (file) {
                    return file === fileToDelete
                })
            };

            $scope.downloadAttachment = function (file) {
                attachmentFileModel.download(file.attachmentFiles[0].id);
            };

            $scope.addStatement = function() {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/popup-patient-statement.html',
                    controller: 'popupPatientStatementController',
                    resolve: {
                        patient: function() {
                            return $scope.patient;
                        },
                        statement: function() {
                            return null;
                        },
                        statementPopup: function() {
                            return $scope.addStatement;
                        }

                    }
                }).then(function() {
                    patientModel.getById($stateParams.patientId);
                    statementModel.getDataPage($scope.statementCriteria);
                }, function() {

                });
            };

            $scope.editStatement = function(statement) {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/popup-patient-statement.html',
                    controller: 'popupPatientStatementController',
                    resolve: {
                        patient: function() {
                            return $scope.patient;
                        },
                        statement: function() {
                            return statement;
                        },
                        statementPopup: function() {
                            return $scope.addStatement;
                        }

                    }
                }).then(function() {
                    patientModel.getById($stateParams.patientId);
                    statementModel.getDataPage($scope.statementCriteria);
                }, function() {

                });
            };

            $scope.deleteStatement = function(statement) {
                var confirm = $mdDialog.confirm({
                    title: $translate.instant('T.MODULE.PERSONAL_DATA.STATEMENT_DELETE_CONFIRMATION'),
                    ok: $translate.instant('T.UI.APPLICATION.YES'),
                    cancel: $translate.instant('T.UI.APPLICATION.NO')
                });
                $mdDialog.show(confirm).then(function() {
                    statementModel.delete(statement);
                }, function() {
                    return false;
                });
            };

            $scope.downloadPDF = function(statement) {
                statementModel.downloadPDF(statement);
            };

            $scope.downloadPDFToFill = function() {
                statementModel.downloadPDFToFill($scope.patient);
            };

            $scope.hasRightToVisitCardModule = function () {
                return userModel.userHasRight(Constant.RIGHT.VISIT_CARD_MODULE_ACCESS);
            };

            $scope.openPrintPatientStateOfHealthDocumentation = function() {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/popup-print-patient-stateOfHealth-documentation.html',
                    controller: 'popupPrintPatientStateOfHealthDocumentationController',
                    resolve: {
                        patient: function() {
                            return $scope.patient;
                        },
                        guardians: function() {
                            return $scope.patient.guardians;
                        },
                        statements: function() {
                            return $scope.statements;
                        }
                    }
                }).then(function(data) {
                    baseModel.broadcastOperationSucceeded();
                }, function() {

                });
            };

        }

        function configureInterface() {
        }

        function initialize() {
            applicationModel.viewReady = true;
            var criteria = {};
            dictionaryModel.getDictionaryElementsDataPage(Constant.DICTIONARY_CODE.CITIZENSHIP, criteria);
            dictionaryModel.getDictionaryElementsDataPage(Constant.DICTIONARY_CODE.STATE, criteria);
            nfzOfficeModel.getDataPage(criteria);
            patientModel.getById($stateParams.patientId);
            statementModel.getDataPage($scope.statementCriteria);
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
